export const FETCH_SUBSCRIPTION = 'FETCH_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const FETCH_SUBSCRIPTION_CHARGE = 'FETCH_SUBSCRIPTION_CHARGE';
export const CREATE_SUBSCRIPTION_CHARGE = 'CREATE_SUBSCRIPTION_CHARGE';
export const UPDATE_SUBSCRIPTION_CHARGE = 'UPDATE_SUBSCRIPTION_CHARGE';
export const FETCH_SUBSCRIPTION_INVOICE = 'FETCH_SUBSCRIPTION_INVOICE';
export const UPDATE_SUBSCRIPTION_INVOICE = 'UPDATE_SUBSCRIPTION_INVOICE_STATUS';

export const SUBSCRIPTION_INVOICE_STATUSES = Object.freeze({
  draft: 'draft',
  open: 'open',
  paid: 'paid',
  uncollectible: 'uncollectible',
  void: 'void',
  refunded: 'refunded',
});
export const SUBSCRIPTION_INVOICE_ACTIONS = Object.freeze({
  refund: 'refund',
  pay: 'pay',
  markUncollectible: 'uncollectible',
});
